import React from 'react';
import moment from 'moment';
import DatePicker from "react-toolbox/lib/date_picker/DatePicker";
import * as utils from "../../../utils/utils";

export default class DateTimePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            m: moment()
        };
    }

    onChange(value) {
        this.props.onChange(parseInt(value / 1000, 10));
    }

    render() {
        return (
            <div className="form-group field datepicker">
                <label className="control-label" htmlFor="root_client">
                    {this.props.title}
                </label>

                <DatePicker
                    className="datepicker"
                    label={this.props.schema.title}
                    value={utils.notNullNorUndefined(this.props.formData) ? new Date(this.props.formData * 1000) : ''}
                    inputFormat={(value) => `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`}
                    onChange={this.onChange.bind(this)}
                    autoOk={true}
                />
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/forms/fields/DateTimePicker.js